import { render, staticRenderFns } from "./ReceiptStatus.vue?vue&type=template&id=9496582c"
import script from "./ReceiptStatus.vue?vue&type=script&lang=js"
export * from "./ReceiptStatus.vue?vue&type=script&lang=js"
import style0 from "./ReceiptStatus.vue?vue&type=style&index=0&id=9496582c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports